export const formatPercent = (value) => `${value?.toFixed(2) || '0.00'}%`;

export const getColor = (value, type) => {
  if (type === 'closed') return 'success.main';
  if (type === 'toTreat') return 'error.main';
  if (type === 'opened') return 'warning.main';
  if (type === 'totalProcessedInPeriod') return 'info.main';
  if (type === 'absorptionRate')
    return value >= 100 ? 'success.main' : 'error.main';
  return 'inherit';
};

export const handleAttachmentFile = async (
  file,
  attachments,
  isFromNewMessage = false
) => {
  const isDuplicate = attachments?.some((att) => {
    return att?.name === file?.name;
  });
  // si l'appel vient d'un des composants enfants de newMessages on gère les duplicates ailleurs pour afficher une modale
  if (isFromNewMessage) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onloadend = async (_e) => {
        const content = fileReader.result;
        resolve({
          file: file,
          link: URL.createObjectURL(file),
          content: content,
          isAtt: true,
        });
      };
      fileReader.onerror = (error) => {
        console.error(error);
        reject(error);
      };
      fileReader.readAsDataURL(file);
    });
  } else {
    if (!isDuplicate) {
      console.log('handleAttachmentFile no duplicate');
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onloadend = async (_e) => {
          const content = fileReader.result;
          resolve({
            file: file,
            link: URL.createObjectURL(file),
            content: content,
            isAtt: true,
          });
        };
        fileReader.onerror = (error) => {
          console.error(error);
          reject(error);
        };
        fileReader.readAsDataURL(file);
      });
    }
  }
};
